var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 4.0625V7.80005C22.75 9.62022 22.75 10.5303 23.1042 11.2255C23.4158 11.837 23.913 12.3342 24.5245 12.6458C25.2197 13 26.1298 13 27.95 13H31.6875M32.5 16.7598V22.75C32.5 27.3004 32.5 29.5756 31.6144 31.3137C30.8355 32.8425 29.5925 34.0855 28.0637 34.8644C26.3256 35.75 24.0504 35.75 19.5 35.75C14.9496 35.75 12.6744 35.75 10.9363 34.8644C9.40751 34.0855 8.16454 32.8425 7.38557 31.3137C6.5 29.5756 6.5 27.3004 6.5 22.75V15.8895C6.5 11.6788 6.5 9.57346 7.26146 7.94077C8.06871 6.2099 9.4599 4.81871 11.1908 4.01146C12.8235 3.25 14.9288 3.25 19.1395 3.25C20.9795 3.25 21.8995 3.25 22.7683 3.44265C23.6935 3.64778 24.5756 4.01318 25.3749 4.52231C26.1255 5.00046 26.776 5.65098 28.077 6.95203L28.6924 7.56739C30.0976 8.97262 30.8002 9.67524 31.3027 10.4952C31.7482 11.2221 32.0765 12.0147 32.2755 12.8437C32.5 13.7788 32.5 14.7725 32.5 16.7598Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export default ForwardRef;